import { useCallback, useEffect, useRef, useState } from "react";


// POLLING DA TELA. SÓ EXISTE ENQUANTO O COMPONENTE QUE USA O HOOK ESTÁ MONTADO (SAIR DA TELA CANCELA TUDO) E PAUSA COM A
// ABA DO NAVEGADOR OCULTA, RETOMANDO COM UMA BUSCA IMEDIATA AO VOLTAR.
//
// O PRÓXIMO CICLO SÓ É AGENDADO DEPOIS QUE A REQUISIÇÃO ATUAL TERMINA (setTimeout ENCADEADO), ENTÃO NUNCA HÁ DUAS EM VOO.
// EM ERRO, O ÚLTIMO `data` É MANTIDO E O CICLO CONTINUA.
//
//   const { data, error, loading, refreshing, lastUpdatedAt, refresh } = usePolling(fetcher, { intervalMs: 30000 });
export default function usePolling(fetcher, { intervalMs }) {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true); // SÓ NA PRIMEIRA CARGA
    const [refreshing, setRefreshing] = useState(false); // ATUALIZAÇÃO MANUAL EM ANDAMENTO
    const [lastUpdatedAt, setLastUpdatedAt] = useState(null);

    // SEMPRE A VERSÃO MAIS RECENTE DO FETCHER, SEM REINICIAR O CICLO A CADA RENDER
    const fetcherRef = useRef(fetcher);
    fetcherRef.current = fetcher;

    const refreshRef = useRef(() => {});


    useEffect(() => {
        let alive = true;
        let inFlight = false;
        let timer = null;

        const clear = () => {
            if (timer) clearTimeout(timer);
            timer = null;
        };

        const schedule = () => {
            clear();

            if (!alive || document.visibilityState === 'hidden') return;

            timer = setTimeout(tick, intervalMs);
        };

        const tick = async () => {
            if (!alive || inFlight) return;

            inFlight = true;
            clear();

            try {
                const result = await fetcherRef.current();

                if (!alive) return;

                setData(result);
                setError(null);
                setLastUpdatedAt(new Date());

            } catch (e) {
                if (!alive) return;

                console.error('ERROR - POLLING FETCH:', e);
                setError(e);

            } finally {
                inFlight = false;

                if (alive) {
                    setLoading(false);
                    setRefreshing(false);
                    schedule();
                }
            }
        };

        const onVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                clear();

            } else {
                tick();
            }
        };

        // ATUALIZAÇÃO MANUAL: BUSCA NA HORA E, AO TERMINAR, O CICLO DE 30 s RECOMEÇA DO ZERO
        refreshRef.current = () => {
            if (inFlight) return;

            setRefreshing(true);
            tick();
        };

        document.addEventListener('visibilitychange', onVisibilityChange);

        tick();

        return () => {
            alive = false;
            clear();
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };

    }, [intervalMs]);


    const refresh = useCallback(() => refreshRef.current(), []);

    return { data, error, loading, refreshing, lastUpdatedAt, refresh };
}
